<div class="section table matched-products" style="display: block">
  <div class="inside">
    <div class="tablehead">
      <h2><ng-content></ng-content></h2>
    </div>
    <table>
      <thead>
        <tr>
          <th i18n="@@table_name">PRODUCT NAME</th>
          <th i18n="@@table_propane">PROPANE</th>
          <th i18n="@@table_iso_butane">ISO-BUTANE</th>
          <th i18n="@@table_n_butane">N-BUTANE</th>
          <th i18n="@@table_pressure">PRESSURE</th>
          <th></th>
        </tr>
      </thead>
      <tbody id="matched">
        @for (product of products; track product) {
          <tr>
            <td>
              <div class="productname"><span class="trade">DRIVOSOL</span> {{ product.name }}</div>
            </td>
            <td>
              <span class="category--headline">Propane</span><input class="milky" name="propane" type="text" [value]="product.propane + ' %'">
            </td>
            <td>
              <span class="category--headline">Iso-Butan</span><input class="milky" name="isobutane" type="text" [value]="product.isobutane + ' %'">
            </td>
            <td>
              <span class="category--headline">N-Butane</span><input class="milky" name="butane" type="text" [value]="product.butane + ' %'">
            </td>
            <td>
              <span class="category--headline">Pressure</span><input class="milky" name="bar" type="text" [value]="product.bar">
            </td>
            <td>
              @if (mode === 'mixing') {
                <a title="pressure" i18n-title="@@pressure" class="button pressure-btn btn-icon" (click)="openPressure(product.bar)"><svg class="icon"><use xlink:href="#icon-pressure"></use></svg></a>
              }
              @if (mode === 'pressure') {
                <a title="mixture" i18n-title="@@mixture" class="button mixing-btn btn-icon" (click)="openMixing(product.name)"><svg class="icon"><use xlink:href="#icon-mixing"></use></svg></a>
              }
              <a title="product information" i18n-title="@@product_information" target="_blank" class="button pdf-btn btn-icon" (click)="openPdf(product)"><svg class="icon"><use xlink:href="#icon-pdf"></use></svg></a>
              <a title="E-Mail" class="button mail-btn btn-icon" (click)="openMail(product)"><svg class="icon"><use xlink:href="#icon-mail"></use></svg></a>
              <a title="Sample order" (click)="openSampleOrder(product)" class="button js_lightbox_trigger order-btn btn-icon"><svg class="icon"><use xlink:href="#icon-spray"></use></svg></a>
            </td>
          }
        </tbody>
      </table>
    </div>
  </div>
